export default{bottomLeft:"w_Fa",bottomRight:"w_Fb",topLeft:"w_Fc",topRight:"w_Fd"};
